import * as helper from './../../../../../VX/View/Assets/Js/helper';

export class SmilyHandler {
	private _visible = false;
	private readonly smilies: HTMLDivElement;
	private button: HTMLImageElement;

	constructor(button, smilies) {
		this.smilies = smilies;
		this.button = button;
		helper.addClickListener(button, this.handleButton.bind(this));
		helper.addClickListener(smilies, this.handleSmile.bind(this))
	}

	handleButton() {
		if (this._visible) {
			helper.hide(this.smilies);
			this._visible = false;
		} else {
			helper.show(this.smilies, 'flex');
			this._visible = true;
		}
	}

	handleSmile(e: MouseEvent) {
		let selected = e.target as HTMLDivElement;
		const input: HTMLInputElement = document.querySelector('#input input');
		let smily = '';
		switch (selected.classList.item(1)) {
			case 'happy':
				smily = ':)';
				break;
			case 'laughing':
				smily = ':D';
				break;
			case 'wink':
				smily = ';)';
				break;
			case 'tongue':
				smily = ':P';
				break;
			case 'sursprised':
				smily = ':O';
				break;
			case 'kiss':
				smily = ':*';
				break;
			case 'sad':
				smily = ':(';
				break;
			case 'neutral':
				smily = ':|';
				break;
		}

		input.value = input.value + ' ' + smily;

		helper.hide(this.smilies);
		this._visible = false;
	}
}
